export function escapeHtml(text: string): string {
	return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function div(content: string | undefined | null, classNames = '') {
	if (!content) {
		return '';
	}

	if (classNames) {
		return `<div class="${classNames}">${content}</div>`;
	}

	return `<div>${content}</div>`;
}

export function span(content: string | undefined | null, classNames: string) {
	if (!content) {
		return '';
	}

	if (classNames) {
		return `<span class="${classNames}">${content}</span>`;
	}

	return `<span>${content}</span>`;
}
